export const REACT_APP_TRACKS_URL='https://media.tracktribe.com/tracks/';

export const genreList = [
    'Alternative & Punk',
    'Ambient',
    'Blues',
    'Cinematic',
    'Country',
    'Dance & Electronic',
    'Folk',
    'Heavy Metal',
    'Hip Hop & Rap',
    'Holiday',
    'Jazz',
    'Pop',
    'R&B & Soul',
    'Reggae',
    'Rock'
];

export const durationRanges = [
    '0 - 30s',
    '30s - 1min',
    '1min - 2min',
    '2min +'
];

export const tempoRanges = [
    'Slow',
    'Medium',
    'Fast'
];

export const moodList = [
    'Angry',         
    'Bouncy',
    'Bright',        
    'Calm',
    'Celebratory',   
    'Chill',
    'Dark',          
    'Dramatic',
    'Emotional',     
    'Energetic',
    'Fun',           
    'Funky',
    'Groovy',        
    'Happy',
    'Inspirational', 
    'Nostalgic',
    'Romantic',      
    'Sad',
    'Soulful',       
    'Upbeat',
    'Uplifting'
];

export const featured_tracks_ids = [
	'605e33b0-d8c1-4527-bb00-a30e29ed3362', // unoriginal
	'c1195719-99f9-41af-896f-a2d241fd6c24', // Sweet Illusion
	'2aec1d0c-3036-4eea-b582-fbafd29d4a36', // back to the night
	'397fe8d3-1e37-4df3-bfdb-267d292e697b', // look in your eyes
	'9977884b-52ae-494a-8f63-fd1166dad8f6', // we are the people
	'f8232121-d558-4e46-be5b-b588d04284e5' // present and past
];




